import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-registration-entry',
  templateUrl: './company-registration-entry.component.html',
  styleUrls: ['./company-registration-entry.component.css']
})
export class CompanyRegistrationEntryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
